import React, { useContext, useState } from "react";
import { RecentlyPlayedTrack, Track } from "../spotify/spotify";
import { ReactComponent as BackArrowIcon } from "../media/back_arrow.svg";
import moment from "moment";
import { organizeRecentlyPlayed } from "../shared/utils/songs.utils";

interface SongListProps {
    songList: RecentlyPlayedTrack[];
    setSelectedSong: (song: RecentlyPlayedTrack) => void;
    back: () => void;
}

const SongList: React.FC<SongListProps> = ({ songList, setSelectedSong, back }) => {
    const songsByDay = organizeRecentlyPlayed(songList);

    return (
        <div className="column-centered">
            <div className='absolute top-3 left-3 cursor-pointer row align-center mx-bw-5' onClick={back}><BackArrowIcon /> <p>Collect Different Songs</p></div>
            <div className="column track-list">
                {
                    songsByDay.map(({date, songs}) => (
                        <div key={date} className="flex flex-col">
                            <p className="text-lg font-bold">{date}</p>
                            { 
                                songs.map(song => (
                                    <div key={song.id} className="row align-center mx-bw-5 my-1 md:my-2 ml-3 md:ml-5">
                                        { song.album.images.length > 0 && <img src={song.album.images[0].url} alt="img" className="album-art-img" /> }
                                        <div className="flex-grow self-stretch column justify-center cursor-pointer ml-1 md:ml-3" onClick={() => setSelectedSong(song)}>
                                            <p className="">{song.name} by <i>{song.artists.map(a => a.name).join(', ')}</i></p>
                                            { song.played_at && <p className="">{moment(song.played_at).format("h:mm a")}</p> }
                                        </div>
                                        { 
                                            song.preview_url ?
                                            <audio controls className="ml-auto">
                                                <source src={song.preview_url} type="audio/mp3" />
                                            </audio> : 
                                            <p className="opacity-50 ml-auto">(no preview available)</p>
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default SongList;
